import React from "react";
import styles from "./styles.module.scss";
import { Flex } from "components/containers/Flex";
import { Spacing } from "spacing/component";
import { with2XS } from "spacing/reducers/vertical";
import menu from "../../assets/svgs/menu-24px.svg";
import INavOption from "./types/INavOption";
import { FullWidth } from "./../../../components/containers/FullWidth/index";
import { classNames } from "helpers/string";
import { SubtitleFont } from "../fonts";

interface IProps {
  activeOption?: INavOption;
  options: INavOption[];
  onChange: (option: INavOption) => void;
  onLogoClick?: () => void;
  logoSrc?: string;
  expanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
  menuSrc?: string;
}

export const SidebarVW = ({
  options,
  activeOption,
  logoSrc,
  menuSrc,
  onChange,
  onLogoClick,
  expanded,
  setExpanded
}: IProps) => (
  <div className={classNames(styles, { expanded })}>
    <Spacing pv="s" ph={expanded ? "s" : "3xs"}>
      <Flex>
        <button onClick={() => setExpanded(!expanded)}>
          <img src={menuSrc ? menuSrc : menu} />
        </button>
      </Flex>
    </Spacing>

    <Spacing
      className={styles.logo}
      pb={expanded ? "m" : "8xl"}
      ph={expanded ? "s" : undefined}
      pt="s"
    >
      <FullWidth>
        <button onClick={onLogoClick}>
          <img src={logoSrc} alt="logo" />
        </button>
      </FullWidth>
    </Spacing>
    <Flex column>
      {options
        .map(option => ({
          option,
          active: option === activeOption,
          onClick: () => onChange(option),
          expanded
        }))
        .map(SidebarOptionVWComponent)
        .reduce(with2XS)}
    </Flex>
  </div>
);

interface SidebarOptionVWModel {
  option: INavOption;
  active?: boolean;
  expanded: boolean;
  onClick: () => void;
}

const SidebarOptionVWComponent = ({
  option,
  onClick,
  expanded
}: SidebarOptionVWModel) => (
  <button {...{ onClick }}>
    <Spacing ph={expanded ? "s" : "3xs"} pv="s">
      <Flex alignItemsCenter>
        <img src={option.src} title={option.label} />
        {expanded && (
          <React.Fragment>
            <Spacing pl="xs" />
            <SubtitleFont>{option.label}</SubtitleFont>
          </React.Fragment>
        )}
      </Flex>
    </Spacing>
  </button>
);
